/** The Variant name the History uses: "{trim} · {engine} ({orderCode})". */
export const variantChangeName = (trimName: string, engineName: string, orderCode: string) =>
  `${trimName} · ${engineName} (${orderCode})`;
